import { useCallback } from 'react';

export interface UseNumberInputProps {
  onChange: (value: number | undefined) => void;
  allowEmpty?: boolean;
  allowZero?: boolean;
}

export const useNumberInput = ({ onChange, allowEmpty = true, allowZero = true }: UseNumberInputProps) => {
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    
    // Handle empty string
    if (value === '' || value === null || value === undefined) {
      if (allowEmpty) {
        onChange(undefined);
        return;
      } else if (allowZero) {
        onChange(0);
        return;
      }
    }
    
    // Parse the number
    const numericValue = parseFloat(value);
    
    // Handle NaN (invalid input)
    if (isNaN(numericValue)) {
      if (allowEmpty) {
        onChange(undefined);
      } else if (allowZero) {
        onChange(0);
      }
      return;
    }
    
    // Handle zero
    if (numericValue === 0 && !allowZero && allowEmpty) {
      onChange(undefined);
      return;
    }
    
    onChange(numericValue);
  }, [onChange, allowEmpty, allowZero]);

  return { handleChange };
};

// Helper function to format number for display
export const formatNumberForInput = (value: number | undefined | null): string => {
  if (value === null || value === undefined) {
    return '';
  }
  return value.toString();
};